<template>
  <div />
</template>

<script>

export default {
  name: 'take-vital-action',
  props: [
    'typeID',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'valueBool',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'VITALS',
        id: this.typeID,
        valueBool: this.valueBool,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
